import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ItemDetailPage = lazy(() => import('../pages/item-detail/page'));
const RulesPage = lazy(() => import('../pages/rules/page'));
const TornarSeVendedorPage = lazy(() => import('../pages/tornar-se-vendedor/page'));
const VendorPage = lazy(() => import('../pages/vendor/page'));
const VendorMeusItensPage = lazy(() => import('../pages/vendor/meus-itens/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const EventoPage = lazy(() => import('../pages/evento/page'));
const MercadoPagoCallbackPage = lazy(() => import('../pages/mercadopago-callback/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const RedefinirSenhaPage = lazy(() => import('../pages/redefinir-senha/page'));
const TermosPage = lazy(() => import('../pages/termos/page'));
const PrivacidadePage = lazy(() => import('../pages/privacidade/page'));
const ContratoEmpresaPage = lazy(() => import('../pages/contrato-empresa/page'));
const TermoOperacionalPage = lazy(() => import('../pages/termo-operacional/page'));
const AtivarContaPage = lazy(() => import('../pages/ativar-conta/page'));

const AdminRoute = ({ defaultTab }: { defaultTab?: string }) => (
  <ProtectedRoute allowedRoles={['admin']}>
    <AdminPage defaultTab={defaultTab} />
  </ProtectedRoute>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/entrar',
    element: <LoginPage />,
  },
  {
    path: '/cadastro',
    element: <RegisterPage />,
  },
  {
    path: '/regras',
    element: <RulesPage />,
  },
  {
    path: '/evento',
    element: <EventoPage />,
  },
  {
    path: '/item/:id',
    element: <ItemDetailPage />,
  },
  {
    path: '/perfil',
    element: (
      <ProtectedRoute allowedRoles={['usuario', 'vendedor']}>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/tornar-se-vendedor',
    element: (
      <ProtectedRoute allowedRoles={['usuario']}>
        <TornarSeVendedorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/vendedor',
    element: (
      <ProtectedRoute allowedRoles={['vendedor', 'admin', 'empresa_admin', 'empresa_operacional']}>
        <VendorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/vendedor/meus-itens',
    element: (
      <ProtectedRoute allowedRoles={['vendedor', 'admin', 'empresa_admin', 'empresa_operacional']}>
        <VendorMeusItensPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/empresa',
    element: (
      <ProtectedRoute allowedRoles={['vendedor', 'admin', 'empresa_admin', 'empresa_operacional']}>
        <VendorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: <AdminRoute />,
  },
  {
    path: '/admin/itens',
    element: <AdminRoute defaultTab="items" />,
  },
  {
    path: '/admin/usuarios',
    element: <AdminRoute defaultTab="users" />,
  },
  {
    path: '/admin/eventos',
    element: <AdminRoute defaultTab="eventos" />,
  },
  {
    path: '/admin/pagamentos',
    element: <AdminRoute defaultTab="payments" />,
  },
  {
    path: '/admin/ciclo',
    element: <AdminRoute defaultTab="ciclo" />,
  },
  {
    path: '/admin/diagnostico',
    element: <AdminRoute defaultTab="diagnostico" />,
  },
  {
    path: '/mercadopago/callback',
    element: <MercadoPagoCallbackPage />,
  },
  {
    path: '/redefinir-senha',
    element: <RedefinirSenhaPage />,
  },
  {
    // Página pública de documentos jurídicos
    path: '/termos',
    element: <TermosPage />,
  },
  {
    path: '/privacidade',
    element: <PrivacidadePage />,
  },
  {
    path: '/contrato-empresa',
    element: <ContratoEmpresaPage />,
  },
  {
    path: '/termo-operacional',
    element: <TermoOperacionalPage />,
  },
  {
    path: '/ativar-conta',
    element: <AtivarContaPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
